import React from 'react';
import PropTypes from 'prop-types';

const FlyOutBasketSummary = ({ className, totalItems, formattedTotal }) => {
  const summaryClassName = `${className}__summary`;

  return (
    <div className={summaryClassName}>
      <span className={`${summaryClassName}__total-items`}>Total items: {totalItems}</span>
      {formattedTotal && (
        <span className={`${summaryClassName}__subtotal`}>
          Subtotal excl delivery & tax: {formattedTotal}
        </span>
      )}
    </div>
  );
};

FlyOutBasketSummary.propTypes = {
  className: PropTypes.string.isRequired,
  totalItems: PropTypes.string,
  formattedTotal: PropTypes.string
};

FlyOutBasketSummary.defaultProps = {
  totalItems: '0',
  formattedTotal: '0'
};

export default FlyOutBasketSummary;
